<template>
  <div id="table-filter" class="clearfix">
    <div v-if="position == 'top'" class="filter-form clearfix">
      <component :is="config.components.PluginSearchBox" :config="searchBoxConfig" @changeFilters="handleChangeFilters" @toggleMoreFilters="toggleMoreFilters" @toggleMoreActions="toggleMoreActions" class="w-100 margin-auto"></component>
      <div v-if="Object.values(previewQueries).length > 0" class="filter-preview w-100 mt-2">
        <ul>
          <li v-for="(object, key) in previewQueries" :key="key" v-show="object && object?.label">
            <i v-if="object?.label" class="ti ti-x" @click.prevent="handleDeleteQuery(key)"></i><span>{{ object?.label }}</span>
          </li>
        </ul>
      </div>
      <div v-if="show.moreFilters || config?.tableConfig?.showTableFilters" class="filter-options w-100 mt-2">
        <component :is="config.components.PluginTableFilters" :config="configTableFilters" @changeFilters="handleChangeFilters"></component>
      </div>
      <div v-if="show.moreActions" class="more-actions w-100 mt-2">
        <component :is="config.components.PluginTableActions" :config="configTableActions" @changeFilters="handleChangeFilters"></component>
      </div>
      <div class="d-flex top mt-3">
        <div class="view-action d-flex align-items-center flex-1">
          <component v-if="config.components.PluginViewActions && (config.tableConfig.showViewActions === undefined || config.tableConfig.showViewActions === true)" :is="config.components.PluginViewActions" :config="{ store, cb }"></component>
        </div>
        <div class="tablenav d-flex justify-content-end align-items-center">
          <div v-if="Object.keys(sort).length > 0" role="group" class="sort-table btn-group btn-group-toggle mr-3">
            <div class="btn btn-light dropdown position-relative p-0">
              <label data-toggle="dropdown" class="m-0 p-2"><i class="ti ti-sort-descending"></i></label>
              <div tabindex="-1" role="menu" class="dropdown-menu">
                <button @click="handleSort(index, 'asc')" v-for="(item, index) in sort" :key="index" type="button" class="dropdown-item">
                  {{ item.text }}
                </button>
              </div>
            </div>
            <div class="btn btn-light dropdown position-relative p-0">
              <label data-toggle="dropdown" class="m-0 p-2"><i class="ti ti-sort-ascending"></i></label>
              <div tabindex="-1" role="menu" class="dropdown-menu">
                <button @click="handleSort(index, 'desc')" v-for="(item, index) in sort" :key="index" type="button" class="dropdown-item">
                  {{ item.text }}
                </button>
              </div>
            </div>
          </div>
          <PageNav :config="configNavPage" @changeValue="pageChange"></PageNav>
        </div>
      </div>
    </div>
    <div v-if="position == 'bottom'" class="filter-form d-flex justify-content-end flex-wrap clearfix">
      <div class="tablenav d-flex flex-wrap w-100 justify-content-end top">
        <PageNav :config="configNavPage" @changeValue="pageChange"></PageNav>
        <br class="clear" />
      </div>
    </div>
  </div>
</template>

<script>
import PageNav from './../PageNav.vue'
export default {
  components: {
    PageNav
  },
  data() {
    return {
      show: {
        moreFilters: false,
        moreActions: false
      }
    }
  },
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    query() {
      return this.store.getter('query', {})
    },
    previewQueries() {
      let queries = {}
      let results = {}
      Object.entries(this.query).forEach(([key, query]) => {
        if (!queries[query?.group || '']) {
          queries[query?.group || ''] = {
            label: '',
            labels: {},
            format: '',
            keys: []
          }
        }
        queries[query?.group || ''].keys.push(key)
        queries[query?.group || ''].labels[key] = query
        if (query?.format) queries[query?.group || ''].format = query.format
      })

      let template = ''
      Object.entries(queries).forEach(([key, group]) => {
        let values = {}
        Object.entries(group.labels).forEach(([k, label]) => {
          values[`${k}.fieldLabel`] = label?.fieldLabel || ''
          values[`${k}.value`] = label?.value || label?.defaultValue || ''
          values[`${k}.valueLabel`] = label?.valueLabel || label?.defaultValueLabel || ''
        })
        if (key != '') {
          if (
            Object.values(group.labels)
              .map((item) => item.valueLabel)
              .join('')
          ) {
            template = group.format || group.keys.map((i) => `{{ ${i} }}`).join(', ')
            template = template.replace(/{{\s*([^}\s]+)\s*}}/g, (match, key) => {
              return values[key] || ''
            })
            results[key] = {
              label: template,
              keys: group.keys
            }
          }
        } else {
          Object.entries(group.labels).forEach(([k, label]) => {
            if (label?.valueLabel) {
              template = label.format || `{{ ${k}.fieldLabel }}: {{ ${k}.valueLabel }}`
              template = template.replace(/{{\s*([^}\s]+)\s*}}/g, (match, key) => {
                return values[key] || ''
              })
              results[k] = {
                label: template,
                keys: [k]
              }
            }
          })
        }
      })
      return results
    },
    cb() {
      return this.config?.cb
    },
    sort() {
      return Object.fromEntries(
        Object.entries(this.store.getter('sort', {})).sort(([, a], [, b]) => {
          return (a.priority || 10) - (b.priority || 10)
        })
      )
    },
    extraAttributes() {
      return this.store.getter('extra_attributes', {})
    },
    screenOptions() {
      return this.store.getter('screen_options', {})
    },
    searchBoxConfig() {
      return {
        extraAttributes: this.extraAttributes,
        query: this.query,
        moreFilters: 'PluginTableFilters' in (this.config?.components || []) && !this.config?.tableConfig?.disableMoreFilters && !this.config?.tableConfig?.showTableFilters,
        moreActions: 'PluginTableActions' in (this.config?.components || []) && !this.config?.tableConfig?.disableMoreActions
      }
    },
    configTableActions() {
      return {
        storeId: this.storeId,
        store: this.store,
        query: this.query,
        cb: this.cb,
        screenOptions: this.screenOptions,
        extraAttributes: this.extraAttributes
      }
    },
    configNavPage() {
      return Object.assign(
        {
          total: 0,
          limit: 10,
          page: 1
        },
        this.query
      )
    },
    configTableFilters() {
      return {
        store: this.store,
        query: this.query,
        screenOptions: this.screenOptions,
        extraAttributes: this.extraAttributes
      }
    }
  },
  methods: {
    handleDeleteQuery(key) {
      if (!this.previewQueries?.[key]?.keys) return
      this.previewQueries?.[key]?.keys.forEach((field) => {
        let object = Object.assign(this.query[field], {
          value: null,
          valueLabel: ''
        })
        this.store.commit(`query.${field}`, object)
      })
    },
    handleSort(field, sort) {
      this.store.commit('query.sort_by', field)
      this.store.commit('query.sort', sort)
      this.$emitter.emit('TableList.Refresh', true)
    },
    handleChangeFilters(query, args) {
      this.store.commit('query', Object.assign(this.query, { ...query }))
      if (args?.refresh) this.$emitter.emit('TableList.Refresh', args?.goToFirst)
    },
    pageChange(page) {
      this.store.commit('query.page', page)
      this.$emitter.emit('TableList.Refresh')
    },
    toggleMoreFilters(value) {
      this.show.moreFilters = value || !this.show.moreFilters
    },
    toggleMoreActions(value) {
      this.show.moreActions = value || !this.show.moreActions
    }
  },
  props: {
    position: {
      type: String,
      default() {
        return 'top'
      }
    },
    config: Object
  }
}
</script>
<style lang="scss">
#table-filter {
  .tablenav {
    .actions {
      > div {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .multiselect {
        margin-top: 10px;
        margin-right: 6px;
        width: auto;
        display: inline-block;
      }
    }
  }
  .tablenav {
    .sort-table {
      .btn,
      label,
      i {
        cursor: pointer;
      }
    }
  }
  .search-form,
  .filter-preview,
  .filter-options,
  .more-actions {
    margin: auto;
    max-width: 650px;
    width: 100%;
    .table-action-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
  }
  .filter-options {
    user-select: none;
    .table-action-wrapper {
      > * {
        max-width: 210px;
        margin: 2px;
      }
    }
  }
  .filter-preview {
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      li {
        color: #2196f3;
        background: #e7f3fe;
        border: 1px solid #c8e5ff;
        padding: 2px 10px 2px 36px;
        margin: 2px;
        border-radius: var(--border-radius, 0.25rem) !important;
        position: relative;
        i {
          position: absolute;
          top: 0;
          left: 0px;
          font-size: 12px;
          padding: 6px;
          border-right: 1px solid #fff;
          cursor: pointer;
        }
      }
    }
  }
  .filter-form {
    .card-body {
      padding: 10px;
    }
  }
}
</style>
